import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=d32f6c9a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=d32f6c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32f6c9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d32f6c9a')) {
      api.createRecord('d32f6c9a', component.options)
    } else {
      api.reload('d32f6c9a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=d32f6c9a&scoped=true&", function () {
      api.rerender('d32f6c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25OhcF1KXrnRx/JS/comp/CookieBox.vue"
export default component.exports